import './DeviceFilter.scss'

import { useEffect, useState } from 'react'
import Lang from '../../../Lang'
import { Button, Classes, Menu, MenuDivider, MenuItem } from '@blueprintjs/core'
import { Popover2 } from '@blueprintjs/popover2'

export default function DeviceFilter({ profiles, devices, value, onChange }) {
	const [searchDeviceID, setSearchDeviceID] = useState('')
	const [searchMsg, setSearchMsg] = useState('')

	function toggleDevice(id) {
		if (!value.includes(id)) {
			onChange((cur) => [...cur, id])
		} else {
			onChange((cur) => cur.filter((cID) => cID != id))
		}
	}

	function toggleProfile(profileId) {
		const idArr = devices.filter((d) => d.lightingProfileId == profileId).map((d) => d.id)
		const allActive = idArr.every((id) => value.includes(id))

		if (!allActive) {
			onChange((cur) => [...new Set([...cur, ...idArr])])
		} else {
			onChange((cur) => cur.filter((el) => !idArr.includes(el)))
		}
	}

	function handleSearch() {
		const validIds = devices.map((d) => d.id)
		if (isNaN(searchDeviceID) || !validIds.includes(parseInt(searchDeviceID))) {
			setSearchMsg(Lang.get('Invalid ID'))
			return
		}

		toggleDevice(parseInt(searchDeviceID))
		setSearchDeviceID('')
		setSearchMsg('')
	}

	const clearDevices = () => onChange([])

	function wantsViewOnMap(event, deviceId) {
		event.stopPropagation()
		window.open(`/?target=${deviceId}`, '_blank')
	}

	const menu = (
		<Menu className="scrollable">
			<MenuItem
				text={Lang.get('All Devices')}
				icon={value.length === 0 ? 'tick' : 'blank'}
				shouldDismissPopover={false}
				onClick={clearDevices}
			/>
			<MenuDivider title={Lang.get('Search...')} />
			<MenuItem
				shouldDismissPopover={false}
				text={
					<div className="search-box">
						{searchMsg && <span>{searchMsg}</span>}
						<div>
							<Button icon="search" onClick={handleSearch} />
							<input
								placeholder={Lang.get('Device ID')}
								value={searchDeviceID}
								onChange={(e) => setSearchDeviceID(e.target.value)}
							/>
						</div>
					</div>
				}
			/>
			<MenuDivider title={Lang.get('Lighting Profiles')} />
			{profiles &&
				profiles.map((p) => {
					const devicesIdsForProfile = devices.filter((d) => d.lightingProfileId == p.id).map((d) => d.id)

					const getIcon = () => {
						if (devicesIdsForProfile.length > 0 && devicesIdsForProfile.every((id) => value.includes(id))) return 'tick'

						const hasSome = devicesIdsForProfile.find((id) => value.includes(id)) != undefined
						if (hasSome) return 'dot'

						return 'blank'
					}

					return (
						<MenuItem
							key={`lp-${p.id}`}
							text={p.title}
							icon={getIcon()}
							onClick={() => toggleProfile(p.id)}
							shouldDismissPopover={false}
							submenuProps={{
								className: 'scrollable'
							}}>
							{devicesIdsForProfile.map((id) => {
								return (
									<MenuItem
										icon={value.includes(id) ? 'tick' : 'blank'}
										text={id}
										key={`lp-i-${id}`}
										onClick={() => toggleDevice(id)}
										shouldDismissPopover={false}
										className="device-item"
										labelElement={
											<Button icon="map" className="wants-view-on-map-btn" onClick={(e) => wantsViewOnMap(e, id)}></Button>
										}
									/>
								)
							})}
						</MenuItem>
					)
				})}
		</Menu>
	)

	return (
		<Popover2 content={menu} position="bottom-right">
			<Button text={Lang.get('Filter')} icon="filter" rightIcon="caret-down" />
		</Popover2>
	)
}
